export enum Role {
    user = "User",
    superAdmin = "SuperAdministrator",
    admin = "Administrator"
  }